// extracted by mini-css-extract-plugin
export default {"card":"DevOpsCard_card__q3Ymr","subTitle":"DevOpsCard_subTitle__u7Add"};